import { useRef } from 'react';

/** Keep failed content's explanation visible while its query retries. */
export function useRetainedLoadError(error: Error | null, isFetching: boolean, scope: string) {
  const previous = useRef<{ scope: string; error: Error | null }>({ scope, error });
  // Never carry an error into a different team/account or beyond a settled read.
  if (previous.current.scope !== scope || error || !isFetching) previous.current = { scope, error };
  return error ?? (isFetching ? previous.current.error : null);
}
